import { render, staticRenderFns } from "./NormalSearchNav368.vue?vue&type=template&id=845972fe&scoped=true"
import script from "./NormalSearchNav368.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav368.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845972fe",
  null
  
)

export default component.exports